import { useQuery } from "@tanstack/react-query";
import getPdfData from "../axios/getPdfData";

const useQueryPdfData = (id: number | null) => {
  return useQuery(
    ["pdf_data", id],
    () => {
      if (id === null) throw new Error("ID is required");
      return getPdfData({ id });
    },
    {
      enabled: id !== null,
    },
  );
};

export default useQueryPdfData;
